import React, { ButtonHTMLAttributes, FC } from 'react'

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const Button: FC<IButton> = (props) => {
    return (
        <button
            {...props}
        />
    )
}
